import React from 'react';
import ExperienceCard from './ExperienceCard';

/**
 * Experience Grid Component
 * Responsive grid layout for experience listings
 */
export default function ExperienceGrid({ experiences }) {
  return (
    <>
      <div className="mb-4 sm:mb-6">
        <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">
          Outdoor adventures near you
        </h1>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 sm:gap-x-6 gap-y-8 sm:gap-y-10">
        {experiences.map((experience) => (
          <ExperienceCard key={experience.id} experience={experience} variant="search" />
        ))}
      </div>

      <div className="mt-8 sm:mt-12 text-center">
        <button className="px-6 sm:px-8 py-3 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition font-medium w-full sm:w-auto">
          Continue exploring
        </button>
      </div>
    </>
  );
}
